var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"d-flex"},[_c('app-input',{attrs:{"label":_vm.$t('switch'),"type":"switch"},on:{"change":_vm.triggerStatus},model:{value:(_vm.statusActive),callback:function ($$v) {_vm.statusActive=$$v},expression:"statusActive"}}),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.value.translated_name))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }